import {
  HardHat,
  Layers,
  ListChecks,
  Ruler,
  Scale,
  type LucideIcon,
} from 'lucide-react';

// Album content-section toggles — one free Switch row each, all default ON.
// `includeBlueprints` gates ONLY the facade projections (blueprint drawings);
// the other sections ship their own flag. Order mirrors Apple/Android:
// Materials first, then the Estimate row, then the remaining four toggles.
export type AlbumSectionToggleKey =
  | 'includeMaterials'
  | 'includeBlueprints'
  | 'includePreparationGuide'
  | 'includeSafetyRequirements'
  | 'includeBuildingRegulations';

export type AlbumSectionToggles = Record<AlbumSectionToggleKey, boolean>;

export interface AlbumSectionToggleRow {
  key: AlbumSectionToggleKey;
  icon: LucideIcon;
  // Key under `album.settings.*` — the row label is `${labelKey}.title`.
  labelKey:
    | 'materials'
    | 'blueprints'
    | 'preparationGuide'
    | 'safetyRequirements'
    | 'buildingRegulations';
}

// The Estimate row renders between "Materials and elements" and the remaining
// section toggles (order mirrors Apple/Android), so the catalog is exported in
// two slices the UI interleaves with the Estimate row.
export const MATERIALS_SECTION_TOGGLE_ROW: AlbumSectionToggleRow = {
  key: 'includeMaterials',
  icon: Layers,
  labelKey: 'materials',
};

export const SECONDARY_SECTION_TOGGLE_ROWS: readonly AlbumSectionToggleRow[] = [
  { key: 'includeBlueprints', icon: Ruler, labelKey: 'blueprints' },
  { key: 'includePreparationGuide', icon: ListChecks, labelKey: 'preparationGuide' },
  { key: 'includeSafetyRequirements', icon: HardHat, labelKey: 'safetyRequirements' },
  { key: 'includeBuildingRegulations', icon: Scale, labelKey: 'buildingRegulations' },
];
